module.exports = "<div class=\"container\">\n    <div class=\"center\">\n      <h2 class=\"mat-h2\">full screen 1</h2>\n      <button type=\"button\" [routerLink]=\"['/']\">home</button>\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/dashboard/countdown/countdown.component.html
// module id = ./src/app/components/dashboard/countdown/countdown.component.html
// module chunks = main